<template>
  <div v-if="loading">
    <v-row
      v-if="!dialogOpened"
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col cols="6">
        Trwa ładowanie danych
        <v-progress-linear
          color="red accent-4"
          indeterminate
          rounded
          height="6"
        />
      </v-col>
    </v-row>

    <v-dialog v-model="dialogOpened" persistent width="400">
      <v-card>
        <v-card-text>
          <v-row
            v-if="loading"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              Trwa ładowanie danych
              <v-progress-linear
                color="red accent-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    dialogOpened() {
      return this.dialog
    }
  }
}
</script>
